// https://cianru.atlassian.net/browse/CD-50840
/* istanbul ignore next */
import { IThunkActionCreator } from '../../types/store';

export interface IGalleryData {
  isVideoPlaying: boolean;
  showElementId: number | undefined;
  isInitialized: boolean;
}

export interface IVideoPlayed {
  type: 'IVideoPlayed';
  gallery: IVideoActionData;
}

export interface IElementShowed {
  type: 'IElementShowed';
  gallery: IElementViewData;
}

export interface IVideoActionData {
  isVideoPlaying: boolean;
}

export interface IElementViewData {
  showElementId: number | undefined;
}

export interface IFotoramaInitialized {
  type: 'IFotoramaInitialized';
  gallery: {
    isInitialized: boolean;
  };
}

export function initialized(): IThunkActionCreator {
  return dispatch => {
    dispatch<IFotoramaInitialized>({
      gallery: {
        isInitialized: true,
      },
      type: 'IFotoramaInitialized',
    });
  };
}

export function playVideo(): IThunkActionCreator {
  return dispatch => {
    dispatch<IVideoPlayed>({
      gallery: {
        isVideoPlaying: true,
      },
      type: 'IVideoPlayed',
    });
  };
}

export function stopPlayVideo(): IThunkActionCreator {
  return dispatch => {
    dispatch<IVideoPlayed>({
      gallery: {
        isVideoPlaying: false,
      },
      type: 'IVideoPlayed',
    });
  };
}

export function showGalleryElement(id: number): IThunkActionCreator {
  return dispatch => {
    dispatch<IElementShowed>({
      gallery: {
        showElementId: id,
      },
      type: 'IElementShowed',
    });
  };
}

export function elementShowed(): IThunkActionCreator {
  return dispatch => {
    dispatch<IElementShowed>({
      gallery: {
        showElementId: undefined,
      },
      type: 'IElementShowed',
    });
  };
}

export function galleryReducer(
  // https://cianru.atlassian.net/browse/CD-50840
  /* istanbul ignore next */
  state: IGalleryData,
  action: IVideoPlayed | IElementShowed | IFotoramaInitialized,
) {
  switch (action.type) {
    case 'IFotoramaInitialized':
      return { ...state, ...action.gallery };

    case 'IVideoPlayed':
      return { ...state, ...action.gallery };

    case 'IElementShowed':
      return { ...state, ...action.gallery };

    default:
      return state || {};
  }
}
